import React, { useEffect, useState } from 'react'
import { Container } from './styles'

export default function About() {
  const [showElement, setShowElement] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowElement(true)
    }, 500) // Mostrar o elemento após meio segundo

    return () => clearTimeout(timer)
  }, [])

  const handleContainerClick = () => {
    window.open(
      'https://drive.google.com/file/d/1qLCd__jCtK4vqpv4jeO5zSWlUZMjFxPf/view?usp=sharing',
      '_blank',
    )
  }

  return (
    <Container>
      {showElement && (
        <>
          <section className='container slide-in' onClick={handleContainerClick}>
            <h4>Clique e veja o meu Currículo</h4>
          </section>
          <section className='infos slide-in'>
            <p>
              Desde criança fascinado por tecnologia desenvolvendo minha curiosidade, conseguindo
              meu primeiro grande feito, baixar e gravar meu primeiro jogo no PS2, e aproveitar
              jogando com os amigos, ainda antes de entender porque, ao invés de gravar DVD, tinha
              escrito o nome queimar DVD no app Nero RS.
            </p>
          </section>
        </>
      )}
    </Container>
  )
}
